export const uploadsKeys = {
  all: () => ['uploads'],
  history: (userId) => [...uploadsKeys.all(), 'history', userId],
  processedFile: (fileId) => [...uploadsKeys.all(), 'processedFile', fileId],
};
